import { useInfiniteRequest } from '@space-shell/common/hooks/useInfiniteRequest'
import { SectionService, SectionsEndpoints } from '@space-shell/common/services/sections'
import { useMembershipStore, useViewAsStore } from '@space-shell/core/store'

import { AMOUNT_PER_PAGE } from '../../constants'

export type useGetSectionsProps = {
  isPreview?: boolean
}

const useGetSections = ({ isPreview = false }: useGetSectionsProps) => {
  const { membershipData } = useMembershipStore()
  const membershipId = membershipData?.id ?? ''
  const { isEnabled: isViewAsEnabled, role: viewAsRole } = useViewAsStore()

  return useInfiniteRequest(
    [SectionsEndpoints.sections(membershipId), String(isViewAsEnabled), String(viewAsRole)],
    ({ pageParam }: { pageParam: string }) => {
      return SectionService.getSections(membershipId, {
        size: AMOUNT_PER_PAGE,
        cursor: pageParam,
        isPreview
      })
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextCursor
    }
  )
}

export default useGetSections
